import { useEffect, useState } from 'react';
import useViewer from '@hooks/useViewer';

const useViewerCompanyNameEffective = () => {
    const [viewerCompanyName, setViewerCompanyName] = useState();
    const { viewer } = useViewer();

    useEffect(() => {
        if (!viewer || (!viewer?.deferredCompany?.name && !viewer?.company?.name)) {
            return;
        }

        setViewerCompanyName(viewer?.deferredCompany?.name ? viewer?.deferredCompany?.name : viewer?.company?.name);
    }, [viewer]);

    return { viewerCompanyName };
};

export default useViewerCompanyNameEffective;
